import { useNavigate, useSearchParams } from 'react-router-dom'
import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { getNavLink } from 'featureSliced/shared/utils/getNavLink'
import {
  findSoldOutLines,
  getRefusedProductIds,
  isSoldOutRefusal,
} from 'featureSliced/shared/utils/soldOut'
import { QRMBucketSlice } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer'
import { ToastsSlice } from 'featureSliced/shared/store/reducers/ToasterReducer'

export const useSoldOutRefusal = () => {
  const t = useTranslations()
  const dispatch = useMyDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const bucketProducts = useMySelector((state) => state.bucket.products)

  return (error: unknown): boolean => {
    if (!isSoldOutRefusal(error)) return false
    findSoldOutLines(bucketProducts, getRefusedProductIds(error)).forEach(
      (line) =>
        dispatch(QRMBucketSlice.actions.removeProductFromBucket(line.uniqueId))
    )
    dispatch(
      ToastsSlice.actions.openToast({
        message: t('products.someProductsAreSoldOut') || '',
        type: 'warning',
      })
    )
    navigate(getNavLink(searchParams, 'menu'))
    return true
  }
}
